import { useEffect } from 'react';
import { analytics, logEvent } from 'utils/firebase';
import PublishRoutes from './routes/PublishRoutes';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

export default function App() {
  const routes = PublishRoutes;

  const router = createBrowserRouter([routes]);
  useEffect(() => {
    logEvent(analytics, 'page_view');
  }, []);

  return (
    <RouterProvider
      router={router}
      errorElement={<div>error</div>}
      fallbackElement={<div>load..</div>}
    />
  );
}
